export default __webpack_public_path__ + "static/media/woocommerce-settings-plugin-WP.fc67c325.gif";